import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { DelayConfig } from './DelayConfig';
import { DelayNode, delayVisualDefinition } from './DelayNode';
import {
  DelayConfigType,
  defaultDelayConfig,
  validateDelayConfig,
  getDelayPreviewText,
} from './schema';

export { DelayNode } from './DelayNode';
export { DelayConfig } from './DelayConfig';
export type { DelayConfigType } from './schema';

/** Full definition for the registry */
export const delayDefinition: NodeDefinition<DelayConfigType> = {
  ...delayVisualDefinition,
  category: 'flow',
  paletteGroup: 'Flow Control',
  NodeComponent: DelayNode as unknown as React.ComponentType<
    NodeProps<Node<BaseNodeData>>
  >,
  ConfigComponent: DelayConfig,
  defaultConfig: () => ({ ...defaultDelayConfig }),
  validateConfig: validateDelayConfig,
  getPreviewText: getDelayPreviewText,
};
